import {
  Component,
  Input,
  Output,
  EventEmitter,
  Optional,
  Self
} from '@angular/core'
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms'
import { DateAdapter } from '@angular/material/core'
import { MatFormFieldAppearance } from '@angular/material/form-field'
import { TranslateService } from '@ngx-translate/core'

import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatDatepickerModule } from '@angular/material/datepicker'

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule]
})
export class DatePickerComponent implements ControlValueAccessor {
  @Input() label: string = ''
  @Input() placeholder: string = 'Select Date'
  @Input() appearance: MatFormFieldAppearance = 'fill'
  @Input() width: string = '100%'
  @Input() cssClass: string = 'primary'
  @Input() calendarIcon: string = 'assets/images/icons/calender.svg'
  @Input() compact: boolean = false
  @Input() startView: 'month' | 'year' | 'multi-year' = 'month'
  @Input() panelClass: string = ''
  @Input() disabled: boolean = false
  @Input() required: boolean = false
  @Input() minDate!: Date
  currentLanguage = localStorage.getItem('lang')

  // @Input() formControl: FormControl | null = null;

  @Output() dateChange = new EventEmitter<Date | null>()
  @Output() yearSelected = new EventEmitter<Date>()
  @Output() monthSelected = new EventEmitter<Date>()

  private onChange = (value: Date | null) => {
    console.log(value)
  }
  private onTouched = () => {}

  value: Date | null = null
  constructor(
    @Optional() @Self() public ngControl: NgControl,
    private translate: TranslateService,
    private dateAdapter: DateAdapter<Date>
  ) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this
    }
    this.setCalenderLanguage()
  }
  onDateSelected(date: Date | null): void {
    this.value = date
    this.onChange(date)
    this.markAsTouched()
    this.dateChange.emit(date)
  }

  onYearSelected(year: Date, datePicker: any): void {
    this.yearSelected.emit(year)
    // Close the datepicker after year selection if needed
    if (this.startView === 'multi-year') {
      datePicker.close()
    }
  }

  onMonthSelected(month: Date, datePicker: any): void {
    this.monthSelected.emit(month)
    // Close the datepicker after month selection if needed
    if (this.startView === 'year') {
      datePicker.close()
    }
  }

  openDatePicker(picker: any): void {
    if (!this.disabled) {
      picker.open()
    }
  }

  // ControlValueAccessor implementation
  writeValue(value: Date | null): void {
    this.value = value
  }

  registerOnChange(fn: (value: Date | null) => void): void {
    this.onChange = fn
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled
  }

  markAsTouched(): void {
    this.onTouched()
    this.control?.markAsTouched()
  }
  // return the actual FormControl, not just errors
  get control(): FormControl | null {
    return this.ngControl?.control as FormControl
  }

  get hasError(): boolean {
    return !!(this.control && this.control.touched && this.control.invalid)
  }

  get errorMessage(): string {
    const errors = this.control?.errors
    if (!errors) return ''
    if (errors['required']) {
      return this.translate.instant('Validations.Required')
    }

    return ''
  }

  setCalenderLanguage() {
    if (this.currentLanguage === 'ar') {
      this.dateAdapter.setLocale('ar-EG')
    } else {
      this.dateAdapter.setLocale('en-GB')
    }
  }
}
